(function (root) {
  'use strict';
  function planForVariant(plans, variantId) {
    const id = String(variantId);
    const matches = plans.filter((row) => String(row.variant_id) === id);
    if (matches.length !== 1) throw new Error('Payment is not available for this selection yet. Please contact support@catterpod.com.');
    const plan = String(matches[0].selling_plan || '');
    if (!/^[1-9]\d*$/.test(plan)) throw new Error('Payment is not available for this selection yet. Please contact support@catterpod.com.');
    return plan;
  }
  function attachPlans(items, plans) {
    // Validate the whole build before any cart request; never submit only part of it.
    return items.map((item) => ({ ...item, selling_plan: planForVariant(plans, item.id) }));
  }
  const api = { planForVariant, attachPlans };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.CatterpodDeferredPayment = api;
})(typeof window !== 'undefined' ? window : globalThis);
